const Types = {
  ORDER_MEAL__SET_FIELD: 'ORDER_MEAL__SET_FIELD',
  ORDER_MEAL__RESET_STATE: 'ORDER_MEAL__RESET_STATE',
};
export default Types;
